import React from "react"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Alert from "@material-ui/lab/Alert"

import Button from "../../components/Button"
import FormContainer from "../../components/FormContainer"

export default function DisclosuresHeader({ children, showAddNew }) {
  return (
    <FormContainer fullWidth transparent wideContent>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Alert severity="warning">
            This feature is open to beta users for feedback. Disclosures may be an upgraded cost in
            the future.
          </Alert>
        </Grid>
        {children ? (
          children
        ) : (
          <>
            <Grid item xs={12} md={showAddNew ? 9 : 12}>
              <Typography paragraph>
                Use the Sales Disclosures to create a 22.1 document required for the unit's sale
                that can be sent to the buyer. All questions should be answered honestly to the best
                of your ability.
              </Typography>
            </Grid>
            {showAddNew ? (
              <Grid
                container
                alignContent="flex-start"
                justifyContent="flex-end"
                item
                xs={12}
                md={3}
              >
                <Button component={Link} to={`/0/sale/add`}>
                  New Disclosure
                </Button>
              </Grid>
            ) : (
              ""
            )}
          </>
        )}
      </Grid>
    </FormContainer>
  )
}
